import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProvinceResponse, HousingResponse, GetZoneRequest } from '../models';
import { ZoneListResponse } from '../../zones/models';
import { OperationHoursAndMap } from 'app/modules/users/models/OperationHoursAndMap';
import { RootState } from 'setup';

interface DispatchState {
  // provinceList: ProvinceResponse[];
  // housingList: HousingResponse[];
  zoneList: ZoneListResponse | null;
  loading: boolean;
  error: string | null;
  operationHoursAndMap: OperationHoursAndMap[]
  loadingGetOperationHoursAndMap: boolean;
}

const initialState: DispatchState = {
  // provinceList: [],
  // housingList: [],
  zoneList: null,
  loading: false,
  error: null,
  operationHoursAndMap: [],
  loadingGetOperationHoursAndMap: false
};

const dispatchSlice = createSlice({
  name: 'dispatch',
  initialState,
  reducers: {
    // fetchProvinceListStart: (state) => {
    //   state.loading = true;
    //   state.error = null;
    // },
    // fetchProvinceListSuccess: (state, action: PayloadAction<ProvinceResponse[]>) => {
    //   state.loading = false;
    //   state.provinceList = action.payload;
    //   state.error = null;
    // },
    // fetchProvinceListFailed: (state, action: PayloadAction<string>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    // clearProvinceList: (state) => {
    //   state.provinceList = [];
    //   state.error = null;
    // },
    // fetchHousingListStart: (state, action: PayloadAction<GetHousingRequest>) => {
    //   state.loading = true;
    //   state.error = null;
    // },
    // fetchHousingListSuccess: (state, action: PayloadAction<HousingResponse[]>) => {
    //   state.loading = false;
    //   state.housingList = action.payload;
    //   state.error = null;
    // },
    // fetchHousingListFailed: (state, action: PayloadAction<string>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    // clearHousingList: (state) => {
    //   state.housingList = [];
    //   state.error = null;
    // },
    fetchZoneListStart: (state, action: PayloadAction<GetZoneRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchZoneListSuccess: (state, action: PayloadAction<ZoneListResponse>) => {
      state.loading = false;
      state.zoneList = action.payload;
      state.error = null;
    },
    fetchZoneListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearZoneList: (state) => {
      state.zoneList = null;
      state.error = null;
    },

    // operation hours and map
    fetchOperationHoursAndMapData(state) {
      state.loadingGetOperationHoursAndMap = true;
    },
    fetchOperationHoursAndMapDataFailed(state) {
      state.loadingGetOperationHoursAndMap = false;
    },
    fetchOperationHoursAndMapDataSuccess(state, action: PayloadAction<OperationHoursAndMap[]>) {
      state.loadingGetOperationHoursAndMap = false;
      state.operationHoursAndMap = action.payload;
    },

  },
});

export const dispatchActions = dispatchSlice.actions;
export const dispatchReducer = dispatchSlice.reducer;

// Selectors
// export const selectProvinceList = (state: any) => state.zone.provinceList;
// export const selectLoadingProvince = (state: any) => state.zone.loading;
// export const selectProvinceError = (state: any) => state.zone.error;
// export const selectHousingList = (state: any) => state.zone.housingList;
// export const selectLoadingHousing = (state: any) => state.zone.loading;
// export const selectHousingError = (state: any) => state.zone.error;
export const selectZoneList = (state: any) => state.dispatch.zoneList;
export const selectLoadingZone = (state: any) => state.dispatch.loading;
export const selectZoneError = (state: any) => state.dispatch.error;

// operation hours and map
export const selectOperationHoursAndMapData = (state: RootState) => state.dispatch.operationHoursAndMap;

